import { Skeleton } from '@components/skeleton/Skeleton';
import { Card, Typography, UsersIcon } from '@gurupay/gp-ui-library';
import { PERMISSION_INFO } from '@pages/settings/profile/utils';
import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import type { Role } from 'types/roles';

interface RoleCardProps {
	role?: Role;
	isLoading: boolean;
}

export const RoleCard: FC<RoleCardProps> = ({ role, isLoading }) => {
	const { t } = useTranslation('', { keyPrefix: 'profile' });
	const roleDetails = role && PERMISSION_INFO[role];

	return (
		<Card className="max-w-[512px] mt-space-40" title={t('roleTitle')}>
			<div className="flex items-center gap-space-16 not-last:border-b border-neutral-100  transition-colors duration-300 px-0">
				<span className="p-space-8 bg-neutral-50 rounded-full">
					<UsersIcon />
				</span>
				<div className="grow">
					{isLoading || !roleDetails ? (
						<Skeleton className="h-[20px] mb-space-4" />
					) : (
						<Typography level="h3">{t(roleDetails.title)}</Typography>
					)}
					{isLoading || !roleDetails ? (
						<Skeleton className="h-[20px]" />
					) : (
						<Typography className="text-neutral-600 text-sm-medium" level="text">
							{t(roleDetails.description)}
						</Typography>
					)}
				</div>
			</div>
		</Card>
	);
};
